<template>
    <div class="entity-compare">
        <v-row class="entity-compare-header m-0">
            <v-col cols="6" class="header-col left"><h4>Before</h4></v-col>
            <v-col cols="6" class="header-col right"><h4>After</h4></v-col>
        </v-row>
        <v-row class="entity-compare-body m-0">
            <v-col cols="6" class="body-col left">
                <notification-consultant-approval-request-form
                    :store="consultant"
                    :is-afert="true"
                ></notification-consultant-approval-request-form>
            </v-col>

            <v-col cols="6" class="body-col right">
                <notification-consultant-approval-request-form
                    :store="consultantSnapShot"
                ></notification-consultant-approval-request-form>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    name: 'NotificationConsultantApprovalRequest',
    components: {},
    props: {},
    data() {
        return {};
    },
    computed: {
        notification() {
            return this.$store.state.notifications.current;
        },
        consultant() {
            return this.$store.state.notification_consultant.consultant;
        },
        consultantSnapShot() {
            return this.$store.state.notification_consultant.consultantSnapShot;
        },
    },
    watch: {},
    created() {},
    methods: {},
};
</script>
